"use strict";

var _classCallCheck = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _regeneratorRuntime = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WSChannel = void 0;

var WebSocket = require("isomorphic-ws");

var events_1 = require("events");

var utils_1 = require("./utils");

var CONNECTION_TIMEOUT = 2000;
var RESPONSE_TIMEOUT = 3000;

var timeout = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ms, message) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (_, reject) {
              var id = setTimeout(function () {
                clearTimeout(id);
                reject(new Error(message !== null && message !== void 0 ? message : "Timed out in ".concat(ms, "ms.")));
              }, ms);
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function timeout(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var defer = function defer() {
  var resolve;
  var reject;
  var promise = new Promise(function (_resolve, _reject) {
    resolve = _resolve;
    reject = _reject;
  });
  return {
    promise: promise,
    resolve: resolve,
    reject: reject
  };
};

var messageIsNotification = function messageIsNotification(input) {
  return !!((input.id === undefined || input.id === null) && input.method);
};

var WSChannel = /*#__PURE__*/function () {
  function WSChannel(url) {
    _classCallCheck(this, WSChannel);

    this.isAlive = false;
    this._requestCounter = 0;
    this._pendingRequests = {};
    this._url = url;
    this._emitter = new events_1.EventEmitter();
  }

  _createClass(WSChannel, [{
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this = this;

        var connectHandler, errorHandler;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this._ws = new WebSocket(this._url);
                this._ws.onclose = this._handleClose.bind(this);
                this._ws.onmessage = this._handleMessage.bind(this);

                this._ws.addEventListener('ping', this._handlePing.bind(this));

                connectHandler = new Promise(function (resolve) {
                  var _a;

                  var onOpen = function onOpen() {
                    var _a;

                    _this.isAlive = true;
                    (_a = _this._ws) === null || _a === void 0 ? void 0 : _a.removeEventListener('open', onOpen);
                    resolve();
                  };

                  (_a = _this._ws) === null || _a === void 0 ? void 0 : _a.addEventListener('open', onOpen);
                });
                errorHandler = new Promise(function (_, reject) {
                  var _a;

                  var onError = function onError(error) {
                    var _a;

                    _this.isAlive = false;
                    (_a = _this._ws) === null || _a === void 0 ? void 0 : _a.removeEventListener('error', onError);
                    reject(error.error);
                  };

                  (_a = _this._ws) === null || _a === void 0 ? void 0 : _a.addEventListener('error', onError);
                });
                _context2.prev = 6;
                _context2.next = 9;
                return Promise.race([connectHandler, errorHandler, timeout(CONNECTION_TIMEOUT, "Could not connect in ".concat(CONNECTION_TIMEOUT, "ms"))]);

              case 9:
                _context2.next = 15;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](6);

                this._ws.close();

                throw _context2.t0;

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 11]]);
      }));

      function connect() {
        return _connect.apply(this, arguments);
      }

      return connect;
    }()
  }, {
    key: "disconnect",
    value: function () {
      var _disconnect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this2 = this;

        var closeHandler;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this._requestCounter = 0;
                this._pendingRequests = {};

                if (this._ws) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt("return");

              case 4:
                if (!(this._ws.readyState === WebSocket.CLOSED)) {
                  _context3.next = 8;
                  break;
                }

                this.isAlive = false;
                this._ws = undefined;
                return _context3.abrupt("return");

              case 8:
                closeHandler = new Promise(function (resolve) {
                  var _a;

                  var onClose = function onClose() {
                    var _a;

                    _this2.isAlive = false;
                    (_a = _this2._ws) === null || _a === void 0 ? void 0 : _a.removeEventListener('close', onClose);
                    resolve();
                  };

                  (_a = _this2._ws) === null || _a === void 0 ? void 0 : _a.addEventListener('close', onClose);
                });

                this._ws.close();

                _context3.next = 12;
                return Promise.race([closeHandler, timeout(CONNECTION_TIMEOUT, "Could not disconnect in ".concat(CONNECTION_TIMEOUT, "ms"))]);

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function disconnect() {
        return _disconnect.apply(this, arguments);
      }

      return disconnect;
    }()
  }, {
    key: "invoke",
    value: function () {
      var _invoke = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(actionName, params) {
        var _a, request, response;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this.isAlive) {
                  _context4.next = 2;
                  break;
                }

                throw new Error('Websocket client is not connected.');

              case 2:
                request = {
                  jsonrpc: '2.0',
                  id: this._requestCounter,
                  method: actionName,
                  params: params !== null && params !== void 0 ? params : {}
                };
                (_a = this._ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify(request));
                response = defer();
                this._pendingRequests[this._requestCounter] = response;
                this._requestCounter += 1;
                return _context4.abrupt("return", Promise.race([response.promise, timeout(RESPONSE_TIMEOUT, "Response not received in ".concat(RESPONSE_TIMEOUT, "ms"))]));

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function invoke(_x3, _x4) {
        return _invoke.apply(this, arguments);
      }

      return invoke;
    }()
  }, {
    key: "subscribe",
    value: function subscribe(eventName, cb) {
      this._emitter.on(eventName, cb);
    }
  }, {
    key: "_handleClose",
    value: function _handleClose() {
      this.isAlive = false;
    }
  }, {
    key: "_handlePing",
    value: function _handlePing() {
      this.isAlive = true;
    }
  }, {
    key: "_handleMessage",
    value: function _handleMessage(event) {
      var res = JSON.parse(event.data);

      if (messageIsNotification(res)) {
        this._emitter.emit(res.method, res.params);
      } else {
        var id = typeof res.id === 'number' ? res.id : parseInt(res.id, 10);

        if (this._pendingRequests[id]) {
          if (res.error) {
            this._pendingRequests[id].reject(utils_1.convertRPCError(res.error));
          } else {
            this._pendingRequests[id].resolve(res.result);
          }

          delete this._pendingRequests[id];
        }
      }
    }
  }]);

  return WSChannel;
}();

exports.WSChannel = WSChannel;